import React from "react";

//firebase
import { db } from 'assets/firebase';

//router
import { Redirect } from "react-router-dom";

// nodejs library that concatenates classes
import classNames from "classnames";

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.jsx";

// core components
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

// Sections for this page
import SectionProblemSolution from "./Sections/SectionProblemSolution.jsx";
import SectionProduct from "./Sections/SectionProduct.jsx";
import SectionProof from "./Sections/SectionProof.jsx";
import SectionVideo from "./Sections/SectionVideo.jsx";
import SectionTestimonials from "./Sections/SectionTestimonials.jsx";
import SectionPrincipals from "./Sections/SectionPrincipals.jsx";
import SectionBrightBeginnings from "./Sections/SectionBrightBeginnings.jsx";
//import SectionPricing from "./Sections/SectionPricing.jsx";
import SubscribeLine from "./Sections/SubscribeLine.jsx";

const dashboardRoutes = [];

class LandingPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      getStarted: false
    }

    this.getStarted = this.getStarted.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }

  getStarted() {
    db.logActivity(null, null, null, null, "get-started", "");
    this.setState({getStarted:true});
  }

  render() {
    const { classes, ...rest } = this.props;

    if (this.state.getStarted === true) {
      return <Redirect to='/get-started' />
    }

    const intercom = document.createElement("script");
    intercom.innerHTML = 'window.Intercom("boot",{ app_id: "l0gl1yia" });';
    document.body.appendChild(intercom);
    
    
    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="All Things EQ"
          links={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "dark"
          }}
          {...rest}
        />
        <Parallax image={require("assets/img/class1.jpg")} filter="dark">
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={9} md={8}>
                <h1 className={classes.title}>The Social Emotional Learning Solution for Schools</h1>
                <h4>
                  Transform your existing school culture into an emotionally intelligent learning environment.
                </h4>
                <br />
                <Button color="warning" onClick={this.getStarted} >Get Started</Button>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)} style={{marginTop:"-123px"}}>
          <div className={classes.main}>
            <SectionProduct />

            <SectionVideo />
            <SectionProblemSolution />
            <SectionProof />
            <SectionTestimonials />
            <SectionPrincipals />
            
            <SectionBrightBeginnings />
            
            <SubscribeLine />
          </div>
        </div>
        <Footer
          content={
            <div>
              <div className={classes.left}>
                <List className={classes.list}>
                  <ListItem className={classes.inlineBlock}>
                    <a
                      href="https://app.allthingseq.com/"
                      className={classes.block}
                    >
                      All Things E.Q.
                    </a>
                  </ListItem>
                  
                </List>
              </div>
              <div className={classes.right} style={{fontSize:"12px"}}>
                &copy; {1900 + new Date().getYear()}{" "}
                AVA School Solutions
              </div>
            </div>
          }
        />
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(LandingPage);



// WEBPACK FOOTER //
// ./src/views/LandingPage/LandingPage.jsx